import { Component, HostBinding, inject } from '@angular/core';
import { VoiceService } from '@app/services/voice.service';

@Component({
  selector: 'app-message-voice-toggle',
  templateUrl: './message-voice-toggle.component.html',
  styleUrls: [],
  imports: [],
  standalone: true,
})
export class MessageVoiceToggleComponent {
  voiceService = inject(VoiceService);

  @HostBinding('class.hidden')
  get isHidden(): boolean {
    return !this.voiceService.audioEnabled();
  }
}
